import { Injectable } from '@angular/core';
import {
  SwUpdate,
  UnrecoverableStateEvent,
  VersionEvent,
  VersionReadyEvent,
} from '@angular/service-worker';
import { filter } from 'rxjs/operators';
import * as Sentry from '@sentry/angular';
import { Analytics, EVENT } from './analytics';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class UpdateService {
  constructor(
    private swUpdate: SwUpdate,
    private analytics: Analytics
  ) {}

  detection(): void {
    if (!this.swUpdate.isEnabled) return;

    this.swUpdate.versionUpdates
      .pipe(
        filter((e: VersionEvent): e is VersionReadyEvent => {
          return e.type === 'VERSION_READY';
        })
      )
      .subscribe((event: VersionReadyEvent) =>
        this.analytics.event(EVENT.SW_VERSION_READY, {
          runningVersion: environment.version,
          currentHash: event.currentVersion?.hash?.slice(0, 8),
          latestHash: event.latestVersion?.hash?.slice(0, 8),
        })
      );

    this.swUpdate.unrecoverable.subscribe((event: UnrecoverableStateEvent) => {
      this.analytics.event(EVENT.SW_UNRECOVERABLE, {
        runningVersion: environment.version,
        reason: event.reason,
      });
      // An unrecoverable cache is an error condition, not just a metric.
      Sentry.captureMessage(
        `Service worker unrecoverable: ${event.reason}`,
        'error'
      );
    });
  }
}
